import { render, staticRenderFns } from "./OrdersFBAEditAdmin.vue?vue&type=template&id=2d4a7d71&scoped=true"
import script from "./OrdersFBAEditAdmin.vue?vue&type=script&lang=js"
export * from "./OrdersFBAEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a7d71",
  null
  
)

export default component.exports